var React = require('react');

function BackInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard Copy"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Artboard-Copy","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M9.6,20.4394769 L44.283871,20.4394769 C49.2387097,20.4394769 49.2387097,27.871735 44.283871,27.871735 L9.6,27.871735 L20.7483871,40.2588317 C23.2258065,42.7362511 18.2709677,47.6910898 15.7935484,43.9749608 L0.929032258,26.6330253 C-0.309677419,25.3943156 -0.309677419,22.9168962 0.929032258,21.6781866 L15.7935484,4.33625108 C18.2709677,0.62012205 23.2258065,5.57496076 20.7483871,8.05238011 L9.6,20.4394769 Z","id":"Path","fill":"#000000"}))]);
}

BackInline.defaultProps = {"width":"48px","height":"48px","viewBox":"0 0 48 48","version":"1.1"};

module.exports = BackInline;

BackInline.default = BackInline;
